import { FC } from 'react'
import { ColorOptions, FontSizeOptions } from '../../theme/UiThemeProvider'
import { Box } from '../BoxNew'
import { Icon } from '../IconNew'

const IconIds = {
  HOME: '\ue902',
  LOGO: '\ue9fb',
  SEARCH: '\ue93a',
  SHARE: '\ue937',
  CLOSE: '\ue925',
  CLEAR: '\ue915',
  LOCATE: '\ue9e6',
  LOCATION: '\ue9fd',
  SOCIETY: '\uea23',
  HISTORY: '\ue90c',
  ARROW_UP: '\ue953',
  ARROW_DOWN: '\ue954',
  SUCCESSFUL_EMPTY: '\ue935',
  SUCCESSFUL_FILLED: '\ue934',
  TICKMARK: '\ue91d',
  RADIOBUTTON_ON: '\ue929',
  RADIOBUTTON_OFF: '\ue92a',
  CHECKBOX_OUTLINE: '\ue94e',
  CHECKBOX_UNCHECKED: '\ue94d',
  CHECKBOX_CHECKED: '\ue950',
  STATUS_SUCCESS: '\ue91d',
  STATUS_PENDING: '\ue942',
  STATUS_AWAITING: '\ue901',
  STATUS_FAILED: '\ue925',
  GOLD_SAVINGS_PLAN: '\ue975',
  BUY_GOLD: '\uea06',
  INCREMENT: '\uea11',
  DECREMENT: '\uea10',
  ARROW_BACK: '\ue921',
  ARROW_RIGHT: '\ue952',
  ARROW_LEFT: '\ue955',
  TIMER: '\ue901',
  FILTER: '\ue92c',
  FILTER2: '\ue9a2',
  FAQ: '\ue946',
  CART: '\ue98f',
  CART_FILLED: '\ue815',
  DOWNLOAD: '\ue947',
  CALENDAR: '\ue94f',
  LOCK: '\ue969',
  INFO: '\ue942',
  DEFAULT_CARD: '\ue94b',
  ICON_CLOSE: '\ue925',
  ICON_REFRESH: '\ue9b1',
  STAR_FILLED: '\ue99a',
  STAR: '\ue99b',
  USER: '\ue92f',
  SORT: '\ue9f0',
  FAVOURITE: '\ue90f',
  FAVOURITE_FILLED: '\ue96e',
  LIST_SORT: '\ue9a5',
  LOCATION_MAP: '\ue963',
  EDIT: '\ue90b',
  MENU: '\ue917',
  RESTAURANT: '\ue9e9',
  WIFI: '\ue982',
  PARKING: '\ue9a9',
  CALL: '\uea0e',
  ROOM_SERVICE: '\ue9c9',
  SETTING: '\ue936',
  NEWBILLER: '\ue932',
  NOTIFICATION: '\ue92b',
  DELETE: '\ue949',
  STOP: '\ue9b0',
  ADD: '\ue959',
  OPTIONS: '\ue916',
  CONTACTS: '\ue99f',
  ADDBILLER: '\ue93d',
  BANK: '\ue95b',
  ROUND_TICK: '\ue935',
  SHOP: '\ue908',
  EXCLAMATION: '\ue948',
  EYE_WATCH: '\uE930',
  EYE_WATCH_SELECTED: '\ue927',
  THUMB_VIEW: '\ue9a1',
  LOAD_MONEY: '\ue971',
  LAYERS: '\ue95e',
  ARROW_45: '\ue9b5',
}

export type IconOptions = keyof typeof IconIds

interface IconButtonProps {
  id: IconOptions
  width?: FontSizeOptions | number
  height?: FontSizeOptions | number
  borderRadius?: string | number
  size?: FontSizeOptions | number
  color?: ColorOptions
  onPress: () => void
  testID?: string
  disabled?: boolean
}

export const IconButton: FC<IconButtonProps> = ({
  width = '32px',
  height = '32px',
  borderRadius = '16px',
  id,
  size,
  color,
  disabled = false,
  onPress = () => {},
  testID,
}) => {
  return (
    <Box
      width={width}
      height={height}
      justify={'center'}
      align={'center'}
      hoverColor={'TRANSPARENT'}
      underlayColor={'TRANSPARENT'}
      borderRadius={borderRadius}
      onPress={!disabled ? onPress : undefined}
      testID={testID}>
      <Icon id={id} size={size} color={color} />
    </Box>
  )
}
